import React from 'react';

const Gallery = () => {
  // Factory images from all uploaded ZIP files (44 total)
  const factoryImages = [
    { url: '/factory-images/DSC00545.JPG', alt: 'Factory Image 1' },
    { url: '/factory-images/DSC00547.JPG', alt: 'Factory Image 2' },
    { url: '/factory-images/DSC00551.JPG', alt: 'Factory Image 3' },
    { url: '/factory-images/DSC00554.JPG', alt: 'Factory Image 4' },
    { url: '/factory-images/DSC00561.JPG', alt: 'Factory Image 5' },
    { url: '/factory-images/DSC00563.JPG', alt: 'Factory Image 6' },
    { url: '/factory-images/DSC00565.JPG', alt: 'Factory Image 7' },
    { url: '/factory-images/DSC00572.JPG', alt: 'Factory Image 8' },
    { url: '/factory-images/DSC00578.JPG', alt: 'Factory Image 9' },
    { url: '/factory-images/DSC00580.JPG', alt: 'Factory Image 10' },
    { url: '/factory-images/DSC00592.JPG', alt: 'Factory Image 11' },
    { url: '/factory-images/DSC00601.JPG', alt: 'Factory Image 12' },
    { url: '/factory-images/DSC00605.JPG', alt: 'Factory Image 13' },
    { url: '/factory-images/DSC00617.JPG', alt: 'Factory Image 14' },
    { url: '/factory-images/DSC00627.JPG', alt: 'Factory Image 15' },
    { url: '/factory-images/DSC00633.JPG', alt: 'Factory Image 16' },
    { url: '/factory-images/DSC00634.JPG', alt: 'Factory Image 17' },
    { url: '/factory-images/DSC00645.JPG', alt: 'Factory Image 18' },
    { url: '/factory-images/DSC00647.JPG', alt: 'Factory Image 19' },
    { url: '/factory-images/DSC00654.JPG', alt: 'Factory Image 20' },
    { url: '/factory-images/DSC00659.JPG', alt: 'Factory Image 21' },
    { url: '/factory-images/DSC00665.JPG', alt: 'Factory Image 22' },
    { url: '/factory-images/DSC00681.JPG', alt: 'Factory Image 23' },
    { url: '/factory-images/DSC00685.JPG', alt: 'Factory Image 25' },
    { url: '/factory-images/DSC00686.JPG', alt: 'Factory Image 26' },
    { url: '/factory-images/DSC00689.JPG', alt: 'Factory Image 27' },
    { url: '/factory-images/DSC00693.JPG', alt: 'Factory Image 28' },
    { url: '/factory-images/DSC00701.JPG', alt: 'Factory Image 29' },
    { url: '/factory-images/DSC00710.JPG', alt: 'Factory Image 30' },
    { url: '/factory-images/DSC00722.JPG', alt: 'Factory Image 31' },
    { url: '/factory-images/DSC00724.JPG', alt: 'Factory Image 32' },
    { url: '/factory-images/DSC00726.JPG', alt: 'Factory Image 33' },
    { url: '/factory-images/DSC00735.JPG', alt: 'Factory Image 34' },
    { url: '/factory-images/DSC00740.JPG', alt: 'Factory Image 35' },
    { url: '/factory-images/DSC00749.JPG', alt: 'Factory Image 36' },
    { url: '/factory-images/DSC00758.JPG', alt: 'Factory Image 37' },
    { url: '/factory-images/DSC00770.JPG', alt: 'Factory Image 38' },
    { url: '/factory-images/DSC00785.JPG', alt: 'Factory Image 40' },
    { url: '/factory-images/DSC00795.JPG', alt: 'Factory Image 41' },
    { url: '/factory-images/DSC00809.JPG', alt: 'Factory Image 43' },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="bg-[#2E368F] text-white py-20" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">Our Gallery</h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Witness the transformation – from traditional farming to modern, efficient drip irrigation systems
          </p>
        </div>
      </section>

      {/* Factory Images Section */}
      <section className="py-16 bg-gray-50" data-testid="gallery-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Factory Images Headline */}
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#2E368F] mb-4">
              Factory Images
            </h2>
            <div className="w-24 h-1 bg-[#6ABD45] mx-auto"></div>
            <p className="text-gray-600 mt-4">{factoryImages.length} photos from our manufacturing facility</p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {factoryImages.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all cursor-pointer bg-white"
                data-testid={`gallery-item-${index}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end">
                  <div className="p-4 text-white">
                    <p className="text-sm font-medium">Ganga Irrigation Factory</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white" data-testid="gallery-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-[#2E368F]">
            Want to See This on Your Farm?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Transform your farm with our proven drip irrigation systems. Get started today!
          </p>
          <a
            href="https://wa.me/919513155159"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#25D366] text-white hover:bg-[#20BA5A] rounded-full px-8 py-4 font-semibold transition-all text-lg"
            data-testid="gallery-whatsapp-button"
          >
            Chat with Us on WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
